module.exports = __webpack_public_path__ + "img/sofort.d5387de5.svg";